<template>
	<span
		class="relative mt-4 w-full py-4 text-center lg:bottom-2 lg:px-10"
		:class="partnerName ? 'text-xs' : 'text-xsm'"
	>
		{{ disclaimerText }}
	</span>
</template>

<script setup lang="ts">
const { partnerName } = useGetPartnerName()

const disclaimerText = computed(() => {
	return partnerName.value
		? `The colour shown is for presentation purposes only and may differ from the actual vehicle colour. Colour availability is subject to stock and may vary.`
		: `Image is for illustration purposes only. Vehicle appearance, including
		colour, may differ from the actual vehicle.`
})
</script>
